import React, { useState, useEffect, useRef } from 'react';
import styled, { keyframes } from 'styled-components';
import axios from 'axios';
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import { db, onSnapshot, doc} from './firebase';

const Container = styled.div`
  height: 100vh;
  font-family: 'Lato', sans-serif;
`;

const ChatContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  height: calc(100vh - 90px);
  
  box-sizing: border-box;
`;

const ChatInputWrapper = styled.div`
  display: flex;
  position:fixed;
  left:20px;
  right:20px;
  bottom:20px;
`;

const ChatInputContainer = styled.form`
  background-color: #F3F3F3;
  padding: 10px;
  border-radius: 15px;
  display: flex;
  bottom:10px;
  width:100%;
  box-sizing: border-box;
`;

const ChatInput = styled.input`
  font-family: 'Lato', sans-serif;
  border: none;
  flex: 1;
  margin-right: 10px;
  padding-left:10px;
  width: 100%;
  font-size: 18px;
  border: 0px;
  background: rgb(255, 255, 255);
  text-align: left;
  
`;

const ChatButton = styled.button`
  text-align: center;
  color: rgb(255, 255, 255);
  background: linear-gradient(rgb(0, 0, 0) 0px, rgb(0, 0, 0) 100%);
  text-transform: uppercase;
  min-height: auto;
  min-width: auto;
  font-size: 18px;
  letter-spacing: 0.05rem;
  padding: 1rem 2rem;
  display: inline-flex;
  -webkit-box-align: center;
  align-items: center;
  cursor: pointer;
  position: relative;
  border: 0.1rem solid transparent;
  transition-duration: 0.1s;
`;

const ChatBubbleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const logo = `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPMAAAAmCAYAAAARBa2jAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAB9FJREFUeNrsXeFt4zoMVoMD7m9vgroTXDpBnAmaTHDxBG0mSDpBchMknSDuBE0nqN8EdTfI3wMe0Cfm6HtGLiFpW5LlRgSMAm0ayxQ/8iMl0RcfHx8qiHn599evS/2jf+rvX75+3QYtBTEpFwWYtfFF+kdk4yZVDZcDQkPJ9Hh2FsALuhvpa6CvWF+Xgn/L9QW6edJjSi04jVx/b27hOSPbutX3iSl7ktiICYcpwMVex5ZtVmTPZTDP9Y+ZzZuC0eprzRkYTuSzxbHAw6dNQHQw1jsEctMx/dTXsgogGF096O+aGwYzZSdDU4xD3+eDAOkFgueZARDoctqQXb0RjnmHz5w5sFnF6bzn8KZ9NII3/eArVFRbAvee6Gujx/FGRQFqovW1wQkcGRpToZ/7QBpZtgdAShBQp+Re63LS4DYbhmElAGRfdNJr6b6g4Fet6L4HOgAK9YwRRwrkPnrskSVHs9D3eG7Z4XUB0AAkLvIu6tiZ/p8FpkuKYD2pT/roeQCiyBNdzHACuUneOyJhTtxEYtRPADQN6DXQacY5VmKC+rPgpCl2tDWdvnQdzIWiNx7p456i3OjhFw7H028pD+saoCE6bxk9riqwLuqzub7GXurBgzH0Idqhh/VBYCKvTxRDuBzqsDgCNPDl4PdXaFz9CvpZNCnknImMFV2sGkEtQutxSdVBcP6pgtfYxmqISzBP0TCrRl0w2O+C3BKqwVIww+cea0Y5GNMtA6QIaNaRfGimZEt3MD62So6GMxJ+LzCGp7A2TUbnndbREFMgKn/OCD0uGNuY1ix41bVZiWRVwZzVNKQUDTfCqNYnok8kXBN9rzmW4n/mmPdSVOq2GHtp/FyFGcaeSMeG3h0meS1cFpwxVDIA+vcS0ZRJhWAF4+bQ1tAmJhQgG7DHdxeOuOdIyaC4oaKXEfoOJx0m5YGKzkeAxHnHm7oThsWUhPlY7En133dALxmW91edRpAnQzBLfH/2nkMl78rRrk0wo1AV0Pgw32Jy42HTPAodDGcwPwJcjaSFwARXB7UQcn678NCuq9nvPuVYks9hdfuSyaN2hsa0Zqj0KOBUPLdjhglOkFpvmJqFtwWvtsGcd9A2Yup5LFThSfrv0bq874DOBUxnxczvtEtFR9dg9sYQGVCUPfGA+NyjBSPcMk4v5M1yXaaMc6RkTS1jBTDTOZ/rqE1VPMv5FkWxbXntbQCzMUDPa8yTZJtoFYHdhR+GrnnrYMaCQyQEkM1xXOJYqPzzRQIeixTsPcDQqIwrBAuvN4aQjssycIqdTj8EuacUzIMqhyJK8h2diSSyrVueF3ASs4BBY9EZNpQAoJ8Vv4MvMX0G3Dcww4Z/m+OoknvGjGNoKmvPJ3MQ4FkL0LChJOOCiurwxpyeB2MAOuNLoQHG8uD5nL0EaNZiifeCIADMbRXA3CCf8SQ/KTZ/+BCV447aU+TgHnkNIIM+pafdRjXTuM+dMwsk8WQdL0encixvz07l2WAklsZ/dc5gZpYN84rfVeeYLVSftwbndmuQUW19AzMFHtfRmOu7xe0ntwFmKjK3rTN43pnlfN7k8puk6HVMjh7IqJsauWhm4JpmpxiNrz0AMrR9+QZKZmg+5VHvLOR2sfJgCY9xgCedkKHOKLcmnh87x/RrPotvjTOM0ey1qr/2WRzSN9WGVdRxEqka1d7nTn9G0gmTikSRhcYK1JJU3nZOj1VhMudUDZb2Sue8T8k/wu+ZKKb1j/q9/vxKOM/9gYwunJiqAubHrh2Mx17GCeFdC887ZL4HejTvCKcAB95TE44KDTBmmI0PkhKAmzXUx71quOtO0N6pSPMk689wIOPFo0443tBs14AGo1sytHAuNF6KjjVuvCdomLB3qp6o9on4W6Rq9knDFINiJpmg5zrX+kep0gqKzQ6fAcwWcmMmz5oJ+mZza88w0a91+m+jAc4FQN561KM5VfzxwqodMSeCHFXizFZMnvxXr2thh8+N751Sv3x2JCOVShgqtcLK5Y6g7EsmB4swQq8laUnFHmASh3JMBobXTPdHPlGnAOgJBWhkPjDuk7S7whtBdlwujhtDqO852foHGibiWPrE/K5Uvc6cV3UdvXBO9mxF+nqaocuc2cYrV3CiKfoHBjdmwPeq5Gupprpzgpx8zYrj16IAOxiW9PGm5Ms+W8xVi0LqQP3fZFEiU6azJqeHTDEdYYTPdNT+Wnw9zZ/xfPrIXPK8S63wAeG5yVasFTfrF9QsVs13c2U+ttktMR7p8k3c0IlwLXK51j/sTsODOabSsq2PBeGeOi/h3k1EFjqExRKTso8mHjtIrsBoSgccteUcrPgkFIKUm2Mv8+ezAnOpN1TticKc64ZxCkYorTLQKNCBTqfK3pFRCTXmNoZUficUsgB2BSOAuX3jA5BwbXZXzHeAkV0rO+u+O8wPh105II+bKjjWU1VSAZAnii5Kpg22USaK7/C5CGBu3/jmzESNuNeqgpFhwWxoCNTF8cvrrvWeOmAsTaN0jiAeM0CWbAxJGjyPi1fGGpVyNTtSpyu1mcsowbyF3siWRsGb7ndV1nVRf1BcgyJbrGRFshzpdO2XvguewyhrkOgExwRGfqtkha8cHeKjVOeMvZq0E+4+O9zi6nIejj7nHzAHceqQ1Dm9Nwqj6OW568FZZA4SJEi35T8BBgA5wSRZneipwgAAAABJRU5ErkJggg==`;

const ChatBubble = styled.div`
  max-width: 800px;
  margin-bottom: 10px;
  border-radius: 15px;
  padding: 10px;
  display:flex;
  flex-direction:row;
  background-color:${props => props.isQuestion ? '#f9f9f9' : '#f0f0f0'};
`;

const Avatar = styled.div`
  width: 100px;
  height: 100px;
  display: flex;
  flex:0;
  align-items: flex-start;
  justify-content: center;
  margin-right: 15px;
  margin-left: 10px;
`;

const AvatarImage = styled.div`
  height: 32px;
  width: 32px;
  margin-top: 17px;
  padding:6px;
  background-image: url('${logo}');
  background-position: center;
  background-size: calc(100% - 12px);
  background-repeat: no-repeat;
  background-color: #000;
`;

const TypingIndicator = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  margin-top:10px;
`;

const wave = keyframes`
  0%, 40%, 100% {
    transform: translateY(0);
  }
  20% {
    transform: translateY(-6px);
  }
`;

const Dot = styled.div`
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: #000;
  margin-right: 5px;
  animation: ${wave} 1s ease-in-out infinite;
  animation-delay: ${props => props.delay}s;

  @keyframes dot {
    0% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-6px);
    }
    100% {
      transform: translateY(0);
    }
  }
`;



let endpoint = 'https://ai-api.proluxe.com/agent'

if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
  endpoint = 'http://localhost:8000/agent'
}


function Chat() {
  const [question, setQuestion] = useState('');
  const [chatHistory, setChatHistory] = useState([]);
  const [isTyping, setIsTyping] = useState(false);
  const [version, setVersion] = useState('');
  const chatContainerRef = useRef(null);

  useEffect(() => {
    onSnapshot(doc(db, "system", "version"), (doc) => {
      setVersion(doc.data().number);
    });
  }, []);

  useEffect(() => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
    }
  }, [chatHistory, isTyping]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    let query = question;
    setQuestion('');

    const newChat = { query: query, answer: '' };
    setChatHistory([...chatHistory, newChat]);
    setIsTyping(true);
    try {
      const response = await axios.post(endpoint, { question: query, version: version, chat_history: [...chatHistory, newChat] }, { headers: { 'Access-Control-Allow-Origin': '*' } });
      const answer = response.data.answer;
      newChat.answer = answer;
      setChatHistory([...chatHistory, newChat]);
    } catch (error) {
      console.error(error);
    } finally {
      setIsTyping(false);
    }  
  };

  const handleChange = (event) => {
    setQuestion(event.target.value);
  };

  return (
    <Container>
      <ChatContainer ref={chatContainerRef}>
        <ChatBubbleContainer>
          {chatHistory.map((chat, index) => (
            <React.Fragment key={index}>
              <ChatBubble isQuestion={true}>{chat.query}</ChatBubble>
              {chat.answer !== '' && <ChatBubble isQuestion={false}>
                <Avatar>
                  <AvatarImage />
                </Avatar>
                <div>
                <ReactMarkdown children={chat.answer} remarkPlugins={[remarkGfm]} />
                </div>
              </ChatBubble>}
            </React.Fragment>
          ))}
          {isTyping && (
            <TypingIndicator>
              <Dot delay={0} />
              <Dot delay={0.2} />
              <Dot delay={0.4} />
            </TypingIndicator>
          )}
        </ChatBubbleContainer>
        <ChatInputWrapper>
        <ChatInputContainer onSubmit={handleSubmit}>
          <ChatInput type="text" value={question} onChange={handleChange} placeholder="Ask a question" />
          <ChatButton type="submit">Ask</ChatButton>
        </ChatInputContainer>
        </ChatInputWrapper>
      </ChatContainer>
    </Container>
  );
}

export default Chat;
